import React from "react";
import { Typography, Box } from "@material-ui/core";
import { CustomCard } from "../../../../../Components";
import { formatNumberCompact } from "../../../../../Helper";
import { useSelectedTheme, useTranslate } from "../../../../../Hooks";

// Icons
import {
  UsersCheck,
  SwitchHorizontal2Icon,
  Building04,
  CoinsStacked03,
  AEDIcon,
} from "../../../../../assets/icons";

// styles
import useStyles from "./styles";

function AfterSalesSummaryCards({ cardsData = {} }) {
  const styles = useStyles();
  const { translate } = useTranslate("AfterSalesView");
  const {
    theme: { palette },
  } = useSelectedTheme();

  const {
    thisMonthTransactions,
    avgTransactionValue,
    totalContacts,
    // activeProperties,
  } = cardsData || {};

  return (
    <Box className={styles.container}>
      <CustomCard
        classes={styles.cardStyle}
        boxShadow="xs"
        borderRadius="xl"
        borderColor="secondary"
      >
        <Typography component="p" variant="body1" className={styles.title}>
          {translate("total-international-clients")}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          marginTop="14px"
          justifyContent="space-between"
          alignItems="center"
          bgcolor="background.paper"
        >
          <Typography variant="h2" component="h2" className={styles.subTitle}>
            {formatNumberCompact(totalContacts)}
          </Typography>
          <Box className={styles.iconContainer}>
            <UsersCheck
              width="24"
              height="24"
              fill={palette.foreground.secondary}
            />
          </Box>
        </Box>
      </CustomCard>
      <CustomCard
        classes={styles.cardStyle}
        boxShadow="xs"
        borderRadius="xl"
        borderColor="secondary"
      >
        <Typography component="p" variant="body1" className={styles.title}>
          {translate("avg-transaction-value")}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          marginTop="14px"
          justifyContent="space-between"
          alignItems="center"
          bgcolor="background.paper"
        >
          <span style={{ display: "inline-flex", alignItems: "flex-start" }}>
            <Typography variant="h2" component="h2" className={styles.subTitle}>
              {avgTransactionValue === undefined ||
              avgTransactionValue === null ||
              avgTransactionValue === ""
                ? "N/A"
                : avgTransactionValue >= 1000
                ? `${Math.round(avgTransactionValue / 1000)}K`
                : avgTransactionValue}
            </Typography>
            <AEDIcon
              width="20"
              height="20"
              fill={palette.text.tertiary}
              style={{ verticalAlign: "super", marginLeft: 4 }}
            />
          </span>
          <Box className={styles.iconContainer}>
            <SwitchHorizontal2Icon
              width="24"
              height="24"
              fill={palette.foreground.secondary}
            />
          </Box>
        </Box>
      </CustomCard>
      {/* <CustomCard
        classes={styles.cardStyle}
        boxShadow="xs"
        borderRadius="xl"
        borderColor="secondary"
      >
        <Typography component="p" variant="body1" className={styles.title}>
          {translate("active-properties")}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          marginTop="14px"
          justifyContent="space-between"
          alignItems="center"
          bgcolor="background.paper"
        >
          <Typography variant="h2" component="h2" className={styles.subTitle}>
            {formatNumberCompact(activeProperties)}
          </Typography>
          <Box className={styles.iconContainer}>
            <Building04
              width="24"
              height="24"
              fill={palette.foreground.secondary}
            />
          </Box>
        </Box>
      </CustomCard> */}
      <CustomCard
        classes={styles.cardStyle}
        boxShadow="xs"
        borderRadius="xl"
        borderColor="secondary"
      >
        <Typography component="p" variant="body1" className={styles.title}>
          {translate("this-month-transactions")}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          marginTop="14px"
          justifyContent="space-between"
          alignItems="center"
          bgcolor="background.paper"
        >
          <Typography variant="h2" component="h2" className={styles.subTitle}>
            {formatNumberCompact(thisMonthTransactions)}
          </Typography>
          <Box className={styles.iconContainer}>
            <CoinsStacked03
              width="24"
              height="24"
              fill={palette.foreground.secondary}
            />
          </Box>
        </Box>
      </CustomCard>
    </Box>
  );
}

export default AfterSalesSummaryCards;
